const TRACK_ENDPOINT = '/hapisumu/track/'

/**
 * ABテストのアクションを記録する。
 * sendBeacon を使うためページ遷移・離脱時でも送信が完了する。
 * 送信は fire-and-forget（結果は確認しない）。
 *
 * @param {string} action アクション名（例: 'contact_clicked'）
 * @param {Object} [context] アクション時のコンテキスト（任意追加情報）
 */
export function trackAction(action, context = {}) {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return

  navigator.sendBeacon(TRACK_ENDPOINT, JSON.stringify({ action, context }))
}

export { TRACK_ENDPOINT }